import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "Nourish Natural Health Clinic";

const TITLES = {
  "/": `${SITE} | Naturopathic Medicine, Acupuncture & Nutrition`,
  "/dr-shannon": "Dr. Shannon May",
  "/the-medicine": "The Medicine",
  "/the-medicine/philosophy": "Our Philosophy",
  "/the-medicine/modalities": "Modalities",
  "/services": "Services",
  "/services/overview": "Services Overview",
  "/services/services": "Our Services",
  "/services/who-we-treat": "Who We Treat",
  "/clinic": "Clinic General Info",
  "/clinic/general-info": "Clinic General Info",
  "/clinic/what-to-expect": "What to Expect",
  "/clinic/faq": "FAQ",
  "/clinic/testimonials": "Testimonials",
  "/clinic/download-forms": "Download Forms",
  "/clinic/order-supplements": "Order Supplements",
  "/resources": "Resources",
  "/resources/e-health-letter": "E-Health Letter",
  "/resources/links": "Links",
  "/resources/recipes": "Recipes",
  "/resources/events-classes": "Events / Classes",
  "/resources/handouts": "Handouts",
  "/resources/articles": "Articles",
  "/resources/recommended-reading": "Recommended Reading",
  "/resources/movies": "Movies",
  "/resources/podcasts": "Podcasts",
  "/contact": "Contact Us",
  "/admin": "Admin Dashboard",
};

export function usePageTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/+$/, "") || "/";
    const t = TITLES[path];
    document.title = path === "/" ? t : t ? `${t} | ${SITE}` : SITE;
  }, [pathname]);
}
